
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/student-services/steps-to-study-abroad",
      function () {
        return require("private-next-pages/student-services/steps-to-study-abroad.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/student-services/steps-to-study-abroad"])
      });
    }
  